import React from 'react'
import { withTheme } from 'styled-components'
import PropTypes from 'prop-types'

import { getPaletteColor } from 'pcln-design-system'

import { getVariationColors } from './colors'

const getPaletteColorFromTheme = (theme) => (shade) => {
  return getPaletteColor(shade)({ theme })
}

const withVariationColors = (Component) => {
  const WrappedComponent = ({ variation = 'vip', fillColor, theme, ...props }) => {
    const getShade = getPaletteColorFromTheme(theme)
    const { primaryColor, secondaryColor } = getVariationColors(variation)

    if (fillColor) {
      const isHexColor = fillColor.indexOf('#') !== -1
      return <Component fillColor={isHexColor ? fillColor : getShade(fillColor)} {...props} />
    }

    return <Component primaryColor={primaryColor} secondaryColor={secondaryColor} {...props} />
  }

  WrappedComponent.displayName = `withVariationColors(${Component.name})`
  WrappedComponent.propTypes = {
    variation: PropTypes.oneOf(['vip', 'dark']),
    fillColor: PropTypes.string,
    theme: PropTypes.object,
  }

  return withTheme(WrappedComponent)
}

export default withVariationColors
